import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";

function LeftCard({ toMap = [], handleTabChange, subTabNo }) {
  return toMap.map((data, index) => (
    <Card
      variant="outlined"
      key={data.id}
      onClick={() => handleTabChange(index)}
      sx={{
        width: "100%",
        height: "8.4rem",
        background: data.id === subTabNo ? "#EBF1F8" : "#FDFDFD",
        border: "1px solid #C0D4E9",
        borderRadius: "8px",
        mb: "16px",
        cursor: "pointer",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          p: "14px",
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              color: "#242424",
              lineHeight: "24px",
              letterSpacing: "0.0015em",
              mb: 1,
              borderLeft: data.id === subTabNo ? "4px solid #3374B9" : "none",
              pl: data.id === subTabNo ? 1 : 0,
            }}
          >
            {data.mainHead}
          </Typography>
        </Box>

        <Box sx={{ overflowX: "scroll" }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 400,
              fontSize: "13px",
              lineHeight: "20px",
              letterSpacing: "0.0025em",
              color: data.id === subTabNo ? "#3374b9" : "#BBBBBB",
            }}
          >
            {data.subHead}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  ));
}

export default LeftCard;
